import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import { findTemplateSectionIndex, isSectionNameUnique } from '../utils/nameUniqueness';
import type { TranslationName } from 'types/translator';

export interface Payload {
  value: {
    collapsed: boolean;
    name: string;
    newName: string;
    title: TranslationName[];
    description?: string;
    tabId?: string | null;
  };
  layoutType: LayoutType;
  currentTabId?: string | null;
}

export const renameSection = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { value, layoutType, currentTabId } = payload;
  const sections = state[layoutType].sections;
  const sourceTabId = currentTabId ?? null;
  const sectionIndex = findTemplateSectionIndex(sections, value.name, sourceTabId);

  if (sectionIndex === -1) return;

  const targetTabId = value.tabId !== undefined ? (value.tabId ?? null) : sourceTabId;
  const otherSections = sections.filter((_, index) => index !== sectionIndex);

  if (!isSectionNameUnique(otherSections, value.newName ?? '', targetTabId)) {
    throw new Error('exists');
  }

  state[layoutType].sections[sectionIndex].name = value.newName;
  state[layoutType].sections[sectionIndex].title = value.title;
  state[layoutType].sections[sectionIndex].collapsed = value.collapsed;
  if (value.description !== undefined) {
    state[layoutType].sections[sectionIndex].description = value.description;
  }
  if (value.tabId !== undefined) {
    state[layoutType].sections[sectionIndex].tabId = value.tabId;
  }
};
